import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { NavigationContainer } from '@react-navigation/native';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { RootNavigator } from './navigation/RootNavigator';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { verifyConfiguration } from './utils/configVerification';
import { EnvironmentBadge } from './components';
import { ActivityIndicator, View, Platform } from 'react-native';
import { ToastProvider } from './contexts/admin/ToastContext';
import { AuthAPI } from './services/residents/api/AuthAPI';
import { useImageCacheCleanup } from '@/hooks/admin/useImageCacheCleanup';
import Config from 'react-native-config';

// TODO: update selector to use reusuable `DesktopDropdownSelector` component

// TODO: feedback modal open when clicking on notification
// TODO: mobile see all notifications not working
// TODO: desktop bulletins orange dot position
// TODO: limit to images only in property chat

// TODO: marketplace preview chat not updating

export const App: React.FC = () => {
  useImageCacheCleanup();
  
  useEffect(() => {
    initializeApp();
  }, []);

  // Set document title on web to prevent it from being overridden to "undefined"
  useEffect(() => {
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
      document.title = 'Resio';
    }
  }, []);

useEffect(() => {
  console.log('Environment Check:', {
    environment: Config.ENVIRONMENT,
    apiUrl: Config.API_BASE_URL,
    timeout: Config.API_TIMEOUT,
    allLoaded: !!(Config.ENVIRONMENT && Config.API_BASE_URL)
  });
}, []);

  const initializeApp = async () => {
    try {
      // Verify configuration
      if (__DEV__) {
        verifyConfiguration();
      }
      
      // Initialize any services here
      // TODO: Initialize certificate pinning
      // TODO: Initialize analytics
      
      // Fetch app configuration (matching iOS behavior)
      try {
        await AuthAPI.fetchConfig();
      } catch (error) {
        console.warn('Failed to fetch app configuration:', error);
        // App continues with default config
      }
    } catch (error) {
      console.error('App initialization failed:', error);
    }
  };

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <Provider store={store}>
        <PersistGate 
          loading={
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
              <ActivityIndicator size="large" color="#007AFF" />
            </View>
          } 
          persistor={persistor}
        >
          <SafeAreaProvider>
            <ToastProvider maxToasts={3}>
              <View style={{ flex: 1 }}>
                <NavigationContainer
                  documentTitle={{
                    formatter: () => 'Resio',
                  }}
                  linking={{
                    prefixes: [
                      'https://beta.resio.com',
                      'https://alpha.resio.com',
                      'https://app.resio.com',
                      'https://app.staging.resio.com',
                      'http://localhost:5173',
                    ],
                    config: {
                      screens: {
                        Auth: {
                          screens: {
                            ResetPassword: 'reset-password',
                            Login: 'login',
                            Signup: 'signup',
                            ForgotPassword: 'forgot-password',
                          },
                        } as any,
                        Main: {
                          screens: {
                            Home: 'home',
                          },
                        } as any,
                      },
                    },
                  }}
                >
                  <RootNavigator />
                </NavigationContainer>
                <EnvironmentBadge />
              </View>
            </ToastProvider>
          </SafeAreaProvider>
        </PersistGate>
      </Provider>
    </GestureHandlerRootView>
  );
}; 